
namespace Matrix.Data {

    @Serenity.Decorators.registerEditor("Matrix.Data.ListItemGrid", [Serenity.IReadOnly])
    @Serenity.Decorators.element("<div/>")
    export class ListItemGrid extends Serenity.EntityGrid<ListItemRow, any> implements Serenity.IReadOnly {
        protected getColumnsKey() { return 'Data.ListItem'; }
        protected getDialogType() { return ListItemDialog; }
        protected getIdProperty() { return ListItemRow.idProperty; }
        protected getLocalTextPrefix() { return ListItemRow.localTextPrefix; }
        protected getService() { return ListItemService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.enableAsyncPostRender = true;
            opt.asyncPostRenderDelay = -1;
            opt.enableAsyncPostRenderCleanup = true;
            return opt;
        }

        protected getInitialTitle() {
            return null;
        }

        private _listCode: string;

        get listCode(): string {
            return this._listCode;
        }

        set listCode(value: string) {
            if (this._listCode !== value) {
                this._listCode = value;
                this.refresh();
            }
        }

        getGridCanLoad() {
            return super.getGridCanLoad() && !Q.isEmptyOrNull(this.listCode);
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as Serenity.ListRequest;
            request.EqualityFilter = request.EqualityFilter || {};
            request.EqualityFilter[ListItemRow.Fields.ListCode] = this._listCode;

            return true;
        }

        addButtonClick() {
            if (!this.listCode)
                return;

            this.editItem(<ListItemRow>{
                ListCode: this.listCode
            });
        }

        protected editItem(id) {
            if (!this._readOnly) {
                super.editItem(id);
            }
        }

        private _readOnly: boolean;

        public get_readOnly() {
            return this._readOnly;
        }

        public set_readOnly(value: boolean) {
            if (!!value !== !!this._readOnly) {
                this._readOnly = !!value;

                this.toolbar.findButton('add-button').toggleClass('disabled', this._readOnly);
            }
        }
    }
}